module.exports = "<h2>GCV Internal Help</h2>\n"